// Utility helpers for OrderItemVertical enum to human-readable strings.
// Centralizes mapping to keep UI consistent across the app.

import * as common_pb from 'respona_api/generated/common_pb';

export function websiteTypeToString(
  value: common_pb.PublisherWebsiteTypeMap[keyof common_pb.PublisherWebsiteTypeMap]
): string {
  switch (value) {
    case common_pb.PublisherWebsiteType.BLOG:
      return 'Blog';
    case common_pb.PublisherWebsiteType.NEWS:
      return 'News';
    case common_pb.PublisherWebsiteType.COMMUNITY_FORUM:
      return 'Community Forum';
    case common_pb.PublisherWebsiteType.AGENCY:
      return 'Agency';
    case common_pb.PublisherWebsiteType.DIRECTORY_LISTINGS:
      return 'Directory Listings';
    case common_pb.PublisherWebsiteType.E_COMMERCE_ONLINE_STORE:
      return 'E-Commerce Online Store';
    case common_pb.PublisherWebsiteType.NON_PROFIT:
      return 'Non-Profit';
    case common_pb.PublisherWebsiteType.SAAS_SOFTWARE_PRODUCT:
      return 'SAAS Software Product';
    case common_pb.PublisherWebsiteType.SERVICE_BUSINESS:
      return 'Service Business';
    case common_pb.PublisherWebsiteType.CORPORATE_COMPANY_WEBSITE:
      return 'Corporate Company Website';
    default:
      return 'Unknown';
  }
}
